import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";

document.addEventListener('DOMContentLoaded', function () {

    const phoneInput = document.querySelector('.phone-field');
    if (phoneInput) {

        const iti = intlTelInput(phoneInput, {
            loadUtilsOnInit: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/24.5.0/build/js/utils.min.js",
            strictMode: true,
            nationalMode: true,
            initialCountry: "auto",
            geoIpLookup: function(callback) {
                fetch("https://ipapi.co/json")
                    .then(response => response.json())
                    .then(data => callback(data.country_code))
                    .catch(() => callback("us"));
            },
            formatOnDisplay: true,
            autoPlaceholder: "polite",
            separateDialCode: true,
        });


        phoneInput.addEventListener('input', function() {
            console.log("Input detected");
            if (iti.isValidNumber()) {
                phoneInput.setCustomValidity("");
            } else {
                phoneInput.setCustomValidity("Please enter a valid phone number.");
            }
        });
    } else {
        console.log("Phone input not found");
    }
});
